module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"email":"Email","firstName":"First Name","lastName":"Last Name","labelSearchVentures":"Search Users"},"de":{"email":"Email","firstName":"First Name","lastName":"Last Name","labelSearchVentures":"Benutzer:innen suchen"}}')
  delete Component.options._Ctor
}
